<div class="bpx-dialog bpx-dialog--wide">
  <h2 mat-dialog-title>Load Study</h2>
  @if (!isLoadStudyConfirmed) {
    <mat-dialog-content>
      <div id="spec_confirmation_message">
        Are you sure you want to exit the current study and load another study?
      </div>
      <mat-dialog-actions class="dialog-actions">
        <button class="bpx-btn bpx-btn--primary" matRipple (click)="confirmLoadStudy()">OK</button>
        <button class="bpx-btn" matRipple [mat-dialog-close]>
          Dismiss
        </button>
      </mat-dialog-actions>
    </mat-dialog-content>
  } @else {
    <mat-dialog-content>
      <div class="select-study-type">
        <div class="bpx-control">
          <span class="bpx-control__label" id="load-study-panel-label">Panels</span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bpx-field">
            <mat-select [(value)]="selectedPanelName" (selectionChange)="panelChangeAction($event)" aria-labelledby="load-study-panel-label">
              @for (panel of panels; track panel) {
              <mat-option [value]="panel.panelName">{{ panel.panelName }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="bpx-control">
          <span class="bpx-control__label" id="load-study-phase-label">Phases</span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bpx-field">
            <mat-select class="sel" [disabled]="!selectedPanelName" [(value)]="selectedPhaseType" (selectionChange)="phaseChangeAction($event)" aria-labelledby="load-study-phase-label">
              <mat-option *ngFor="let phaseType of phaseTypes; let i = index" [value]="phaseType.value">
                {{ phaseType.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="bpx-control">
          <span class="bpx-control__label" id="load-study-user-label">User</span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bpx-field">
            <mat-select [(value)]="selectedUserName" (selectionChange)="userChangeAction($event)" aria-labelledby="load-study-user-label">
              <mat-option [value]="undefined">All Users</mat-option>
              @for (user of users; track user.email) {
                <mat-option [value]="user.email">{{ user.first_name }} {{ user.last_name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      @if (!!errorMessage) {
        <div class="bpx-error" role="alert">
          <mat-icon>error_outline</mat-icon>
          <span>{{ errorMessage }}</span>
        </div>
      }
      @if (isProcessing) {
        <div class="load-study-status">
          Loading...
        </div>
      } @else if (selectedStudies && selectedStudies.length > 0) {
      <div class="study-filter">
        <input matInput type="search" class="bpx-input"
          placeholder="Filter..." [(ngModel)]="studyFilterText" (input)="applyStudyFilter()">
      </div>
      <div class="study-list bpx-scroll-card" [style.--user-col-width]="userColWidth">
        <mat-selection-list [multiple]="false" [(ngModel)]="selectedStudy">
          @for (study of filteredStudies; track study) {
          <mat-list-option [value]="study">
            <div class="study-row">
              <span class="study-name">
                <span class="study-name-text">{{ study.run_name }}</span>
                <span *ngIf="study.is_draft" class="draft-label">(Draft)</span>
                <span *ngIf="study.is_committed" class="committed-label">(Committed)</span>
              </span>
              <span class="study-user">{{ study.user ?? '' }}</span>
              <span class="study-date">{{ study.date ? (study.date | date:'MM-dd-yyyy') : '' }}</span>
            </div>
          </mat-list-option>
          }
        </mat-selection-list>
      </div>
      } @else {
      <p class="bpx-empty" *ngIf="selectedStudies?.length === 0">
        No Studies Found
      </p>
      }
    </mat-dialog-content>
    <mat-dialog-actions class="dialog-actions">
      <button class="bpx-btn bpx-btn--primary" matRipple [mat-dialog-close] (click)="load()">Load</button>
      <button class="bpx-btn bpx-btn--danger" matRipple (click)="deleteStudy()" [disabled]="!selectedStudy?.length || isProcessing">Delete</button>

      <button class="bpx-btn" matRipple [mat-dialog-close]>Dismiss</button>
    </mat-dialog-actions>
  }
</div>
